<div
        copoVirtualScroller
        [dataId]="dataId"
        #scroller="copoVirtualScroller"
        (moreDataNeeded)="onMoreDataNeeded($event.index, $event.limit, $event.provideData)"
        class="copo-no-user-select sidenav-content copo-order-tracking-block"
        @routeAnimation
        cdkScrollable>
	<div class="order-tracking-list-title" translate>search.certificates</div>
	<div class="order-tracking-grid copo-container">
		<div *ngFor="let document of scroller.list" class="card-block">
			<div class="card-header">
					<div class="card-header-left">
						<mat-icon svgIcon="icon_certificate" class="header-margin-right"></mat-icon>
						<span class="header-margin-right overflow-wrap">{{document.typeDescription ? document.typeDescription :
							UNDERSCORE}}</span>
					</div>
					<div class="card-container-link">
						<a mat-icon-button [href]="getDocumentURL(document.id, document.name) | copoSafeUrl" target="_blank"
							type="application/pdf" class="icon-color" [title]="'quapp.action.view' | translate">
							<mat-icon svgIcon="md:eye"></mat-icon>
						</a>
						<a mat-icon-button [href]="downloadDocument(document.id, document.name) | copoSafeUrl" target="_blank"
							type="application/pdf" class="icon-color" [title]="'sb.Download' | translate">
							<mat-icon svgIcon="md:download"></mat-icon>
						</a>
					</div>
			</div>
				<div class="card-content">
					<div class="content-grid-mobile">
						<div class="text-overflow-ellipsis">
							<div class="card-content-label" translate>commercial-documents.certificate-number</div>
							<a class="card-header-value"
								[routerLink]="['/commercial-documents/cards/certificate-card', document.id]">
								{{ document.name ? document.name : UNDERSCORE}}
							</a>
						</div>
						<div>
							<div class="card-content-label" translate>commercial-documents.certificate-type</div>
							<div>{{ document.subtypeDescription ? document.subtypeDescription : UNDERSCORE }}</div>
						</div>
						<div class="card-header-right">
							<mat-icon svgIcon="calendar" class="header-margin-right grey-icon"></mat-icon>
							<div class="card-container-column">
								<span class="card-content-label" translate>datacenter-filter.creation-date</span>
								<span>{{ (document.date ? document.date : UNDERSCORE) | copoDate:'date' }}</span>
							</div>
						</div>
						<div>
							<div class="card-content-label" translate>commercial-documents.mill</div>
							<div>{{ document.millDescription ? document.millDescription : UNDERSCORE }}</div>
						</div>
						<div class="card-header-double-span">
							<div class="card-container-row">
								<span class="card-content-label" translate>commercial-documents.customer-order-number</span>
								<span class="card-content-label" translate>commercial-documents.supplier-order-number</span>
								<span class="card-content-label" translate>datacenter-filter.batch-reference</span>
							</div>
							<div *ngFor="let docLine of document.documentLines; let i = index">
								<div class="card-container-row" *ngIf="i < 3">
									<div>
										{{ document.customerOrderReference ? document.customerOrderReference : UNDERSCORE }}
									</div>
									<div>
										{{ document.supplierOrderReference ? document.supplierOrderReference : UNDERSCORE }}
									</div>
									<div>
										{{ docLine.batchNumber ? docLine.batchNumber : UNDERSCORE}}
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="card-container-column card-column-end">
					<a mat-button color="primary"
						(click)="redirectToBatchDatacenter(document)" [routerLink]="['/order-tracking/batch/datacenter']">
						<span translate>order.card.document.display.batches</span>
						<mat-icon iconPositionEnd color="accent" svgIcon="md:chevron_right"></mat-icon>
					</a>
					<a mat-button color="primary"
						(click)="redirectToOrderDatacenter(document)" [routerLink]="document.docNavigationLink">
						<span translate>commercial-documents.display-all-orders</span>
						<mat-icon iconPositionEnd color="accent" svgIcon="md:chevron_right"></mat-icon>
					</a>
				</div>
			</div>
			<copo-loading-spinner *ngIf="scroller.loading"></copo-loading-spinner>
		<div translate class="empty-page-text" *ngIf="!scroller.loading && scroller.list.length === 0">order-tracking.no.result</div>
	</div>
</div>
